import { render, staticRenderFns } from "./AdminPersonPicker.vue?vue&type=template&id=5b268a62&scoped=true"
import script from "./AdminPersonPicker.vue?vue&type=script&lang=js"
export * from "./AdminPersonPicker.vue?vue&type=script&lang=js"
import style0 from "./AdminPersonPicker.vue?vue&type=style&index=0&id=5b268a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b268a62",
  null
  
)

export default component.exports